<nz-collapse>
  <nz-collapse-panel [nzHeader]="'JUPITER.TITLE' | translate">
    <nz-row [nzGutter]="[20, 20]">
      <nz-col *ngIf="renderNoSomeDataAlert" [nzSpan]="24">
        <nz-alert nzType="warning" [nzMessage]="'JUPITER.NO_SOME_DATA' | translate"></nz-alert>
      </nz-col>

      <nz-col *ngIf="comment" [nzSpan]="24">
        <app-lot-moto-jupiter-inspection-comment
          [comment]="comment"
        ></app-lot-moto-jupiter-inspection-comment>
      </nz-col>

      <nz-col *ngIf="images360?.length > 0" [nzSpan]="24" #wrapper360>
        <app-three-sixty-viewer [images]="images360" [wrapperElement]="wrapper360"></app-three-sixty-viewer>
      </nz-col>

      <nz-col
        *ngFor="let inspectionInfo of inspectionInfos; trackBy: inspectionInfoIdentity"
        [nzXs]="24"
        [nzSm]="24"
        [nzMd]="12"
      >
        <app-lot-moto-jupiter-inspection-card
          [inspectionInfo]="inspectionInfo"
          (noData)="noData($event)"
        ></app-lot-moto-jupiter-inspection-card>
      </nz-col>
    </nz-row>
  </nz-collapse-panel>
</nz-collapse>
